module.exports = __webpack_public_path__ + "img/1461.55df91be.png";